import type { HelpFile } from '../../types/help'
import { BackgroundJobsDashboardTestIds } from '../../../testids/BackgroundJobsDashboardTestIds'

export const backgroundJobsDashboardHelp: HelpFile = {
  docPage: '/docs/jobs/job-scheduler',
  texts: {
    [BackgroundJobsDashboardTestIds.backgroundJobsDashboardPage]:
      'Cluster-wide health overview — what is running, what just failed, and which jobs need triage.',
    [BackgroundJobsDashboardTestIds.statTotalJobs]:
      'Registered jobs across all sources (system, user, integration).',
    [BackgroundJobsDashboardTestIds.statRunningNow]:
      'Executions currently in flight on a cluster node.',
    [BackgroundJobsDashboardTestIds.statFailed24h]:
      'Executions that ended in failure during the last 24 hours.',
    [BackgroundJobsDashboardTestIds.statAvgDuration]:
      'Mean wall-clock duration of recent successful executions.',
    [BackgroundJobsDashboardTestIds.cardTitleNeedsAttention]:
      'Jobs whose latest execution failed, is overdue, or is stuck — triage starts here.',
    [BackgroundJobsDashboardTestIds.needsAttention]: null,
    [BackgroundJobsDashboardTestIds.allHealthy]:
      'No jobs need attention — everything has run on schedule.',
    [BackgroundJobsDashboardTestIds.cardTitleRecentExecutions]:
      'Most recent executions across the cluster, newest first.',
    [BackgroundJobsDashboardTestIds.recentExecutions]: null,
    [BackgroundJobsDashboardTestIds.cardTitleSourceBreakdown]:
      'Job distribution by source — system tasks versus integrations versus user-defined.',
    [BackgroundJobsDashboardTestIds.sourceBreakdown]: null,
  },
}
